/**
 * PUSH sells subscriptions, PRESS sells passes to walk-ins, and All spans
 * both — where someone holding one of each is a single person, not two
 * members. Every Income label that names the people it is about takes its
 * noun from here rather than hardcoding "Member".
 *
 * These are whole keys rather than one interpolated noun because Spanish
 * agrees adjectives with gender: "Nuevos suscriptores" but "Nuevas
 * personas".
 */
const NOUNS = {
  push: {
    column: "income.subscriberColumn",
    plural: "income.subscriberColumnPlural",
    new: "income.newSubscribers",
    newTooltip: "income.newSubscribersTooltip",
    churned: "income.churnedSubscribers",
    churnedTooltip: "income.churnedSubscribersTooltip",
  },
  press: {
    column: "income.memberColumn",
    plural: "income.memberColumnPlural",
    new: "income.newMembers",
    newTooltip: "income.newMembersTooltip",
    churned: "income.churnedMembers",
    churnedTooltip: "income.churnedMembersTooltip",
  },
  all: {
    column: "income.peopleColumn",
    plural: "income.peopleColumnPlural",
    new: "income.newPeople",
    newTooltip: "income.newPeopleTooltip",
    churned: "income.churnedPeople",
    churnedTooltip: "income.churnedPeopleTooltip",
  },
};

const peopleNouns = (context) => NOUNS[context] || NOUNS.press;

export default peopleNouns;
